module.exports = __webpack_public_path__ + "static/media/success-email.352731c5.png";